<aside class="nav-left">

  <!-- Header (bouton retour) — mode drilldown -->
  @if (navLeft.config().headerTemplate) {
    <div class="nav-left__header">
      <ng-container *ngTemplateOutlet="navLeft.config().headerTemplate!"></ng-container>
    </div>
  }

  <!-- Toolbar (search + blast + filter) -->
  @if (navLeft.config().searchTemplate) {
    <div class="nav-left__search">
      <ng-container *ngTemplateOutlet="navLeft.config().searchTemplate!"></ng-container>
    </div>
  }

  <!-- Actions (boutons extra) — mode area -->
  @if (navLeft.config().actionsTemplate) {
    <div class="nav-left__actions">
      <ng-container *ngTemplateOutlet="navLeft.config().actionsTemplate!"></ng-container>
    </div>
  }

  <!-- Onglets Filter / Settings — uniquement si settingsTemplate fourni -->
  @if (hasSettings()) {
    <div class="nav-left__tabs">
      <button
        class="nav-left__tab"
        [class.nav-left__tab--active]="activeTab() === 'filter'"
        (click)="activeTab.set('filter')">
        <img src="assets/icon/new_icon/filter.svg" width="14" height="14" alt="" />
        Filter
      </button>
      <button
        class="nav-left__tab"
        [class.nav-left__tab--active]="activeTab() === 'settings'"
        (click)="activeTab.set('settings')">
        <img src="assets/icon/new_icon/settings_black.svg" width="14" height="14" alt="" />
        Settings
      </button>
    </div>
  }

  <!-- Onglet Filter : site card + treeview -->
  @if (!hasSettings() || activeTab() === 'filter') {

    <!-- Site card (nom du site) — mode drilldown -->
    @if (navLeft.config().siteCardTemplate) {
      <div class="nav-left__site-card">
        <ng-container *ngTemplateOutlet="navLeft.config().siteCardTemplate!"></ng-container>
      </div>
    }

    <!-- TreeView — toujours présent -->
    <div class="nav-left__tree">
      <app-tree-view
        [data]="navLeft.config().treeData"
        [searchText]="navLeft.config().searchText || ''"
        [selectedId]="navLeft.config().selectedNodeId"
        [labelEllipsis]="navLeft.config().labelEllipsis || 'end'"
        [showCheckbox]="navLeft.config().showCheckbox ?? true"
        [showSelectAll]="navLeft.config().showSelectAll ?? true"
        [showGuides]="navLeft.config().showGuides ?? true"
        [persistKey]="navLeft.config().persistKey ?? 'area.selectedNodeId'"
        [selectParent]="navLeft.config().selectParent ?? true"
        [showExpandCollapse]="navLeft.config().showExpandCollapse ?? false"
        (nodeClick)="handleNodeClick($event)"
        (badgeClick)="navLeft.config().onBadgeClick?.($event)"
        (checkboxChange)="navLeft.config().onCheckboxChange?.($event)"
        (selectAllChange)="navLeft.config().onSelectAll?.($event)"
      ></app-tree-view>
    </div>
  }

  <!-- Onglet Settings : grouping dynamique -->
  @if (hasSettings() && activeTab() === 'settings') {
    <div class="nav-left__settings">
      <ng-container *ngTemplateOutlet="navLeft.config().settingsTemplate!"></ng-container>
    </div>
  }

</aside>
